export interface ChartData {
  name: string;
  value: number;
  [key: string]: string | number;
}

export enum Page {
  DASHBOARD = 'dashboard',
  PLAYGROUND = 'playground',
  DB_MONITOR = 'db_monitor',
  USERS = 'users',
  CHATS = 'chats',
  MEMORY = 'memory',
  DOCUMENTS = 'documents',
  TIERS = 'tiers',
  API_KEYS = 'api_keys',
  IMAGE_PRESETS = 'image_presets',
  USAGE = 'usage',
  LOGS = 'logs',
  ADMIN_ACCOUNTS = 'admin_accounts',
  SETTINGS = 'settings',
}

// Tier types are exported from api/tiers.ts
